var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Danh sách học sinh",
            visible: _vm.isStudentChangeOnlinePaymentDialog,
            width: "1100px",
            "panel-icon": "el-icon-user",
            "panel-title": "DANH SÁCH HỌC SINH",
            "panel-subtitle":
              "Danh sách chi tiết học sinh ghi nhận thay đổi hạn mức trong kỳ.",
            "show-confirm": false,
            "cancel-text": "Đóng hộp thoại",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isStudentChangeOnlinePaymentDialog = $event
            },
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-inner-body" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingData,
                      expression: "loadingData",
                    },
                  ],
                  ref: "multipleTable",
                  staticClass: "modern-table",
                  attrs: {
                    "element-loading-text": "Đang tải danh sách học sinh...",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255,255,255,0.7)",
                    data: _vm.studentList,
                    "highlight-current-row": "",
                    border: "",
                    "max-height": _vm.tableMaxHeight,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "STT",
                      width: "55",
                      align: "center",
                      fixed: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "kidCode",
                      label: "Mã học sinh",
                      width: "140",
                      align: "center",
                      fixed: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("code", { staticClass: "code-badge" }, [
                              _vm._v(_vm._s(row.kidCode)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Họ và tên học sinh",
                      prop: "name",
                      "min-width": "180",
                      fixed: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "student-name" }, [
                              _vm._v(_vm._s(row.name)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Giới tính",
                      prop: "gender",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.gender === "Nữ" ? "danger" : "primary",
                                  size: "medium",
                                  effect: "plain",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.gender) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Lớp học",
                      prop: "className",
                      "min-width": "150",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "class-text" }, [
                              _vm._v(_vm._s(row.className)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Khối học",
                      prop: "gradeName",
                      "min-width": "150",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "grade-text" }, [
                              _vm._v(_vm._s(row.gradeName)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper mt-3 flex justify-center" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.pageNumber,
                      "page-sizes": _vm.$pageListDefaultUser || [
                        10, 20, 50, 100,
                      ],
                      "page-size": _vm.maxPageItem,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.pageTotal,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }